<template>
  <div class="page">
    <div class="page-header">
      <h1 class="page-title">Advocacy Setting</h1>
      <breadcrumb name="ADVOCACY_LIST"></breadcrumb>
      <div class="page-header-actions">
        <button
          v-if="activeTab === 'characters'"
          type="button"
          class="btn btn-round btn-primary"
          @click="createCharacter"
        >
          <i class="icon md-plus" aria-hidden="true"></i>
          Create
        </button>
        <button
          v-else-if="activeTab === 'questions' && !isQuestionEditing"
          type="button"
          class="btn btn-round btn-primary"
          @click="createQuestion"
        >
          <i class="icon md-plus" aria-hidden="true"></i>
          Create
        </button>
      </div>
    </div>

    <div class="page-content page-content-table">
      <div class="container-fluid">
        <div class="panel">
          <nav class="nav nav-pills nav-fill">
            <a
              :class="tabClass('skus')"
              href="javascript:void(0)"
              @click="activeTab = 'skus'"
            >
              SKUs
            </a>
            <a
              :class="tabClass('characters')"
              href="javascript:void(0)"
              @click="activeTab = 'characters'"
            >
              Characters
            </a>
            <a
              :class="tabClass('questions')"
              href="javascript:void(0)"
              @click="activeTab = 'questions'"
            >
              Question Pool
            </a>
          </nav>

          <div class="panel-body p-0">
            <div v-if="activeTab === 'skus'" class="page-content container-fluid">
              <div class="row">
                <div class="col-lg-12 col-xl-12">
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col" class="t1"></th>
                        <th scope="col" class="t2">Status</th>
                        <th scope="col" class="t3">Label:</th>
                        <th scope="col" class="t4">Description</th>
                        <th scope="col" class="t5"></th>
                        <th scope="col" class="t6"></th>
                        <th scope="col" class="t7"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(sku, index) in skus" :key="sku.id || index">
                        <th class="t1">No.{{ index + 1 }}</th>
                        <th class="t2">
                          <select
                            v-model="skus[index].status"
                            class="form-control"
                            @change="submitSku('status', skus[index].id, index)"
                          >
                            <option
                              value="active"
                              :disabled="skus[index].status == 'active'"
                              :hidden="skus[index].status == 'active'"
                            >
                              ACTIVE
                            </option>
                            <option
                              value="inactive"
                              :disabled="skus[index].status == 'inactive'"
                              :hidden="skus[index].status == 'inactive'"
                            >
                              INACTIVE
                            </option>
                          </select>
                        </th>
                        <th class="t3">
                          <input
                            v-model="skus[index].label"
                            type="text"
                            class="form-control"
                            maxlength="50"
                            @change="submitSku('label', skus[index].id, index)"
                          />
                        </th>
                        <th class="t4">
                          <input
                            v-model="skus[index].description"
                            type="text"
                            class="form-control"
                            maxlength="255"
                            @change="submitSku('description', skus[index].id, index)"
                          />
                        </th>
                        <th class="t5">
                          <img :src="skus[index].thumbnail" alt="SKU thumbnail" />
                        </th>
                        <th class="t6">
                          <input
                            :ref="'fileUpload' + skus[index].id"
                            type="file"
                            style="display: none;"
                            accept="image/*"
                            @change="onSkuFileSelected"
                          />
                          <button
                            type="button"
                            class="btn btn-round btn-default mx-10"
                            @click="displayRef('fileUpload' + skus[index].id, skus[index].id)"
                          >
                            <i class="fa fa-file-text-o" style="font-size: 18px;"></i>
                          </button>
                        </th>
                        <th class="t7">
                          <button
                            type="button"
                            class="btn btn-round btn-default mx-10"
                            @click="removeSku(skus[index].id, skus[index].image)"
                          >
                            <i class="fa fa-trash-o" style="font-size: 18px;"></i>
                          </button>
                        </th>
                      </tr>
                    </tbody>
                  </table>

                  <button
                    type="button"
                    class="btn btn-round btn-default mx-10"
                    @click="addSku"
                  >
                    <i class="fa fa-plus" aria-hidden="true"></i>
                    Add
                  </button>
                </div>
              </div>
            </div>

            <div v-else-if="activeTab === 'characters'" class="page-content container-fluid">
              <div class="row mb-20">
                <div class="col-md-5">
                  <input
                    v-model.trim="characterKeyword"
                    type="text"
                    class="form-control"
                    placeholder="Search Char Name or Char Description"
                  />
                </div>
              </div>

              <vue-good-table
                :columns="characterColumns"
                :rows="filteredCharacters"
                :pagination-options="{ enabled: true, mode: 'records' }"
                @on-row-click="openCharacterDetail"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field === 'image_url'">
                    <img
                      v-if="props.row.image_url"
                      class="imageTable imageTable--large"
                      :src="props.row.image_url"
                      alt="Character thumbnail"
                    />
                    <span v-else class="text-muted">n/a</span>
                  </span>
                  <span v-else-if="props.column.field === 'background_url'">
                    <img
                      v-if="props.row.background_url"
                      class="imageTable imageTable--large"
                      :src="props.row.background_url"
                      alt="Character background"
                    />
                    <span v-else class="text-muted">n/a</span>
                  </span>
                  <span v-else-if="props.column.field === 'modified_time'">
                    {{ formatDate(props.row.modified_time) }}
                  </span>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] || 'n/a' }}
                  </span>
                </template>
              </vue-good-table>
            </div>

            <div v-else class="page-content container-fluid">
              <div class="row">
                <div class="col-lg-12 col-xl-12">
                  <div v-if="isQuestionEditing">
                    <div class="panel panel-bordered">
                      <div class="panel-heading">
                        <div class="form-row align-items-center">
                          <div class="form-group col-md-6 mb-0">
                            <h3>
                              Question - {{ questionForm.id }}
                              {{ questionForm.name || '' }}
                            </h3>
                          </div>
                          <div class="form-group col-md-6 mb-0 text-right">
                            <div class="btn-group">
                              <button
                                type="button"
                                class="btn btn-primary btn-round dropdown-toggle"
                                data-toggle="dropdown"
                                aria-expanded="false"
                                style="text-transform: uppercase;"
                              >
                                {{ questionForm.status }}
                              </button>
                              <div class="dropdown-menu" role="menu">
                                <a
                                  v-if="questionForm.status == 'active'"
                                  class="dropdown-item"
                                  href="javascript:void(0)"
                                  role="menuitem"
                                  @click="submitQuestionStatus('inactive')"
                                >
                                  Inactive
                                </a>
                                <a
                                  v-if="questionForm.status == 'inactive'"
                                  class="dropdown-item"
                                  href="javascript:void(0)"
                                  role="menuitem"
                                  @click="submitQuestionStatus('active')"
                                >
                                  Active
                                </a>
                              </div>
                              <button
                                type="button"
                                class="btn btn-round btn-default mx-15"
                                @click="closeQuestionEditor"
                              >
                                Back to List
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <form class="form-horizontal">
                      <div class="form-group row align-items-center">
                        <label class="col-sm-2 col-form-control-label">
                          Question Name
                        </label>
                        <div class="col-sm-5">
                          <input
                            v-model="questionForm.name"
                            type="text"
                            class="form-control"
                            maxlength="50"
                            @change="submitQuestionField('name')"
                          />
                        </div>
                        <label class="col-sm-2 col-form-control-label question-points-label">
                          Question Points
                        </label>
                        <div class="col-sm-2">
                          <input
                            v-model.number="questionForm.points"
                            type="number"
                            min="0"
                            max="10000"
                            class="form-control question-points-input"
                            @change="submitQuestionField('points')"
                          />
                        </div>
                      </div>

                      <div class="form-group row">
                        <label class="col-sm-2 col-form-control-label">
                          Question Text
                        </label>
                        <div class="col-sm-6">
                          <input
                            v-model="questionForm.text"
                            class="form-control"
                            type="text"
                            maxlength="64"
                            @change="submitQuestionField('text')"
                          />
                        </div>
                      </div>

                      <div class="form-group row align-items-start">
                        <label class="col-sm-2 col-form-control-label">
                          Character
                        </label>
                        <div class="col-sm-6">
                          <select
                            v-model="questionForm.character_id"
                            class="form-control"
                            @change="submitQuestionField('character_id')"
                          >
                            <option :value="null" disabled>
                              Please choose....
                            </option>
                            <option
                              v-for="character in characters"
                              :key="character.id"
                              :value="character.id"
                            >
                              {{ character.name || `Character ${character.id}` }}
                            </option>
                          </select>
                        </div>
                      </div>

                      <div class="form-group row">
                        <label class="col-sm-2 col-form-control-label">
                          Char Picture
                        </label>
                        <div class="col-sm-6">
                          <img
                            v-if="selectedQuestionCharacter && selectedQuestionCharacter.image_url"
                            :src="selectedQuestionCharacter.image_url"
                            alt="Character preview"
                            class="preview"
                          />
                          <div v-else class="text-muted py-10">No image</div>
                        </div>
                      </div>

                      <table class="table">
                        <thead>
                          <tr>
                            <th scope="col" class="t1-e">Choices</th>
                            <th scope="col" class="t2-e"></th>
                            <th scope="col" class="t3-e"></th>
                            <th scope="col" class="t4-e"></th>
                            <th scope="col" class="t5-e">Correct Answer</th>
                            <th scope="col" class="t6-e"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="choice in questionChoices" :key="choice.key">
                            <th class="t1">No.{{ choice.key }}</th>
                            <th class="t2">
                              <div class="form-group row mb-0">
                                <label class="col-sm-2 col-form-control-label">
                                  SKU:
                                </label>
                                <div class="col-sm-8">
                                  <select
                                    v-model="choice.value.sku_id"
                                    class="form-control"
                                    @change="submitQuestionChoice(choice.key)"
                                  >
                                    <option :value="null">Please choose....</option>
                                    <option
                                      v-for="sku in skus"
                                      :key="sku.id"
                                      :value="sku.id"
                                      :disabled="sku.status == 'inactive'"
                                      :hidden="sku.status == 'inactive'"
                                    >
                                      {{ sku.label }}
                                    </option>
                                  </select>
                                </div>
                              </div>
                            </th>
                            <th>
                              {{ showSku(choice.value.sku_id, 'status') | toUpperCase }}
                            </th>
                            <th>
                              <img
                                :src="showSku(choice.value.sku_id, 'thumbnail')"
                                alt="SKU thumbnail"
                              />
                            </th>
                            <th>
                              <div class="center">
                                <input
                                  v-model="choice.value.correct_answer"
                                  type="checkbox"
                                  class="form-check-input"
                                  :true-value="1"
                                  :false-value="0"
                                  @change="submitQuestionChoice(choice.key)"
                                />
                              </div>
                            </th>
                            <th>
                              <button
                                type="button"
                                class="btn btn-round btn-default mx-10"
                                @click="deleteQuestionChoice(choice.key)"
                              >
                                <i class="fa fa-trash-o" style="font-size: 18px;"></i>
                              </button>
                            </th>
                          </tr>
                        </tbody>
                      </table>
                    </form>
                  </div>

                  <div v-else>
                    <vue-good-table
                      :columns="questionColumns"
                      :rows="questionRows"
                      :search-options="{ enabled: true }"
                      :pagination-options="{ enabled: true, mode: 'records' }"
                      @on-row-click="openQuestionEditor"
                    >
                      <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'thumbnail'">
                          <img
                            v-if="props.row.thumbnail"
                            class="imageTable"
                            :src="props.row.thumbnail"
                            alt="Character thumbnail"
                          />
                          <span v-else class="text-muted">n/a</span>
                        </span>
                        <span v-else-if="props.column.field == 'status'">
                          {{ props.row.status | toUpperCase }}
                        </span>
                        <span v-else-if="props.column.field == 'modified_time'">
                          {{ formatDate(props.row.modified_time) }}
                        </span>
                        <span v-else>
                          {{ props.formattedRow[props.column.field] || 'n/a' }}
                        </span>
                      </template>
                    </vue-good-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal name="confrim-modal" :width="600" height="auto">
      <ConfrimModal
        :idSkus="removeSkuId"
        :image="removeSkuImage"
        @sucessRemove="fetchSkus"
      />
    </modal>
  </div>
</template>

<script>
import {
  skuService,
  uploadgameService,
  questionService,
  characterService,
} from "@/api/client";
import ConfrimModal from "@/views/advocacy/confrim.vue";
import {
  characterTableColumns,
  questionTableColumns,
} from "./model";

const cloneDeep = (value) => JSON.parse(JSON.stringify(value));

export default {
  name: "AdvocacyList",

  components: { ConfrimModal },

  data() {
    return {
      activeTab: "questions",
      skus: [],
      characters: [],
      questions: [],
      questionForm: null,
      oldQuestionForm: null,
      selectedfile: null,
      characterColumns: characterTableColumns,
      questionColumns: questionTableColumns,
      removeSkuId: null,
      removeSkuImage: null,
      nowSkuId: null,
      characterKeyword: "",
    };
  },

  computed: {
    isQuestionEditing() {
      return !!this.questionForm;
    },

    filteredCharacters() {
      const keyword = (this.characterKeyword || "").trim().toLowerCase();
      const rows = this.characters.map((character) => ({
        ...character,
        description: character.description || "",
      }));

      if (!keyword) return rows;

      return rows.filter((character) => {
        const name = (character.name || "").toLowerCase();
        const description = (character.description || "").toLowerCase();

        return name.includes(keyword) || description.includes(keyword);
      });
    },

    questionRows() {
      return this.questions.map((question) => ({
        ...question,
        character_name: this.questionCharacterName(question),
        thumbnail: this.questionCharacterThumbnail(question),
      }));
    },

    questionChoices() {
      if (!this.questionForm || !this.questionForm.choices) return [];

      return Object.keys(this.questionForm.choices)
        .sort((left, right) => Number(left) - Number(right))
        .map((key) => ({
          key,
          value: this.questionForm.choices[key],
        }));
    },

    selectedQuestionCharacter() {
      if (!this.questionForm) return null;

      return this.findCharacterByQuestion(this.questionForm);
    },
  },

  created() {
    this.fetchPageData();
  },

  methods: {
    tabClass(tab) {
      return this.activeTab === tab
        ? "nav-item nav-link active"
        : "nav-item nav-link";
    },

    async fetchPageData() {
      await Promise.all([
        this.fetchSkus(),
        this.fetchCharacters(),
        this.fetchQuestions(),
      ]);
    },

    async fetchSkus() {
      this.skus = await skuService.getSku({ show_all: 1 });
    },

    async fetchCharacters() {
      this.characters = await characterService.getCharacter({ show_all: 1 });
    },

    async fetchQuestions() {
      this.questions = await questionService.getQuestion({ show_all: 1 });
    },

    async addSku() {
      await skuService.createSku({});
      await this.fetchSkus();
    },

    removeSku(id, image) {
      this.removeSkuImage = null;
      this.removeSkuId = id;

      if (image) {
        const pieces = image.split(/[\s/]+/);
        this.removeSkuImage = pieces[pieces.length - 1];
      }

      this.$modal.show("confrim-modal");
    },

    checkSku(field, index) {
      switch (field) {
        case "status":
          if (this.skus[index].image == null) {
            this.skus[index].status = "inactive";
            this.alert("กรุณา Upload Image ก่อน");
            return false;
          }
          return true;
        default:
          return true;
      }
    },

    async submitSku(field, id, index) {
      try {
        const check = this.checkSku(field, index);
        if (!check) return;

        const form = {};
        form[field] = this.skus[index][field];
        await skuService.editSku(id, form);
        await this.fetchSkus();
        this.$notify(
          `${field.charAt(0).toUpperCase() + field.slice(1)}`.replace(
            /_/gi,
            " "
          ) + " updated."
        );
      } catch (error) {
        error.response
          ? this.$dialogs.alert(error.response.data)
          : this.$notify("SKUs Update error");
      }
    },

    displayRef(ref, id) {
      const inputRef = this.$refs[ref];
      const input = Array.isArray(inputRef) ? inputRef[0] : inputRef;

      if (input) {
        input.click();
      }

      this.nowSkuId = id;
    },

    onSkuFileSelected(event) {
      this.selectedfile = event.target.files[0];
      this.uploadSkuImage(this.selectedfile);
    },

    async uploadSkuImage(image) {
      try {
        if (!image) return;
        if (!this.checkSkuImageType(image)) return;

        const form = new FormData();
        form.append("image", image, image.name);
        await uploadgameService.upload(`/ams/api/sku/${this.nowSkuId}/upload`, form);

        this.nowSkuId = null;
        this.$notify("Updated");
        await this.fetchSkus();
      } catch (error) {
        error.response
          ? this.$dialogs.alert(error.response.data)
          : this.$dialogs.alert(error);
      }
    },

    checkSkuImageType(image) {
      const validImageTypes = ["image/jpeg", "image/png"];

      if (!validImageTypes.includes(image.type)) {
        this.alert("เกิดข้อผิดพลาด File image ต้องเป็น jpg และ png");
        return false;
      }

      return true;
    },

    async createCharacter() {
      try {
        const created = await characterService.createCharacter({});
        const id = created && created.id ? created.id : null;

        if (!id) {
          this.$notify("Create character success");
          await this.fetchCharacters();
          return;
        }

        this.$router
          .push({ name: "AdvocacyCharacterDetail", params: { id } })
          .catch(() => {});
      } catch (error) {
        error.response
          ? this.$dialogs.alert(error.response.data)
          : this.$dialogs.alert(error.message || error);
      }
    },

    openCharacterDetail(params) {
      const row = params.row || params;

      this.$router
        .push({ name: "AdvocacyCharacterDetail", params: { id: row.id } })
        .catch(() => {});
    },

    async createQuestion() {
      try {
        const created = await questionService.createQuestion({});
        const id = created && created.id ? created.id : null;

        await this.fetchQuestions();

        if (id) {
          await this.loadQuestion(id);
        }
      } catch (error) {
        error.response
          ? this.$dialogs.alert(error.response.data)
          : this.$dialogs.alert(error.message || error);
      }
    },

    async openQuestionEditor(params) {
      const row = params.row || params;
      await this.loadQuestion(row.id);
    },

    async loadQuestion(id) {
      this.questionForm = await questionService.getById(id);

      if (
        (this.questionForm.points === null ||
          this.questionForm.points === undefined) &&
        this.questionForm.fpoins !== null &&
        this.questionForm.fpoins !== undefined
      ) {
        this.questionForm.points = this.questionForm.fpoins;
      }

      if (
        this.questionForm.fpoins !== null &&
        this.questionForm.fpoins !== undefined
      ) {
        this.questionForm.fpoins = Number(this.questionForm.points || 0);
      }

      if (
        (this.questionForm.character_id === null ||
          this.questionForm.character_id === undefined) &&
        this.questionForm.character
      ) {
        const legacyCharacter = this.characters.find(
          (character) => character.character === this.questionForm.character
        );

        if (legacyCharacter) {
          this.questionForm.character_id = legacyCharacter.id;
        }
      }

      if (
        this.questionForm.points === null ||
        this.questionForm.points === undefined
      ) {
        this.questionForm.points = 0;
      }

      this.oldQuestionForm = cloneDeep(this.questionForm);
    },

    async closeQuestionEditor() {
      this.questionForm = null;
      this.oldQuestionForm = null;
      await this.fetchQuestions();
    },

    questionCharacterName(question) {
      const character = this.findCharacterByQuestion(question);

      if (character) {
        return character.name || `Character ${character.id}`;
      }

      return question.character || "";
    },

    questionCharacterThumbnail(question) {
      const character = this.findCharacterByQuestion(question);
      return character ? character.image_url : "";
    },

    findCharacterByQuestion(question) {
      if (!question) return null;

      if (
        question.character_id !== null &&
        question.character_id !== undefined
      ) {
        const byId = this.characters.find(
          (character) => Number(character.id) === Number(question.character_id)
        );

        if (byId) return byId;
      }

      if (question.character) {
        return (
          this.characters.find(
            (character) => character.character === question.character
          ) || null
        );
      }

      return null;
    },

    showSku(id, field) {
      if (id == null) {
        return field === "thumbnail" ? "" : "n/a";
      }

      const sku = this.skus.find((item) => Number(item.id) === Number(id));
      if (!sku) {
        return field === "thumbnail" ? "" : "n/a";
      }

      switch (field) {
        case "status":
          return sku.status;
        case "thumbnail":
          return sku.thumbnail;
        default:
          return "n/a";
      }
    },

    validateQuestionField(field) {
      if (!this.questionForm || !this.oldQuestionForm) return true;

      switch (field) {
        case "points": {
          const value = Number(this.questionForm.points);

          if (!Number.isInteger(value) || value < 0 || value > 10000) {
            this.alert("Question Points สามารถใส่ได้ตั้งแต่ 0-10000");
            this.questionForm.points = this.oldQuestionForm.points;
            return false;
          }

          this.questionForm.points = value;
          return true;
        }
        default:
          return true;
      }
    },

    async submitQuestionField(field) {
      try {
        if (!this.validateQuestionField(field)) return;

        const form = {};
        if (field === "points") {
          form[this.getQuestionPointsField()] = this.questionForm.points;
        } else {
          form[field] = this.questionForm[field];
        }

        await questionService.editQuestion(this.questionForm.id, form);
        await this.loadQuestion(this.questionForm.id);
        await this.fetchQuestions();
        this.$notify(
          `${field.charAt(0).toUpperCase() + field.slice(1)}`.replace(
            /_/gi,
            " "
          ) + " updated."
        );
      } catch (error) {
        error.response
          ? this.$dialogs.alert(error.response.data)
          : this.$notify("Question Update error");
      }
    },

    async submitQuestionChoice(choiceKey) {
      try {
        const item = this.questionForm.choices[choiceKey];
        const form = {
          sku_id:
            item.sku_id === null || item.sku_id === ""
              ? null
              : Number(item.sku_id),
          correct_answer: Number(item.correct_answer) || 0,
        };

        await questionService.editQuestionChoice(
          this.questionForm.id,
          choiceKey,
          form
        );
        await this.loadQuestion(this.questionForm.id);
        this.$notify("Choices updated.");
      } catch (error) {
        error.response
          ? this.$dialogs.alert(error.response.data)
          : this.$notify("Question Choices Update error");
      }
    },

    async deleteQuestionChoice(choiceKey) {
      try {
        const form = {
          sku_id: null,
          correct_answer: 0,
        };

        await questionService.editQuestionChoice(
          this.questionForm.id,
          choiceKey,
          form
        );
        await this.loadQuestion(this.questionForm.id);
        this.$notify("Delete success.");
      } catch (error) {
        error.response
          ? this.$dialogs.alert(error.response.data)
          : this.$notify("Question Choices Delete error");
      }
    },

    async submitQuestionStatus(status) {
      try {
        await questionService.editQuestion(this.questionForm.id, { status });
        this.$notify("Change Status success");
        await this.loadQuestion(this.questionForm.id);
        await this.fetchQuestions();
      } catch (error) {
        error.response
          ? this.$dialogs.alert(error.response.data)
          : this.$notify(error.message || error);
      }
    },

    formatDate(value) {
      return value ? String(value).slice(0, 16) : "";
    },

    getQuestionPointsField() {
      return Object.prototype.hasOwnProperty.call(this.questionForm || {}, "fpoins")
        ? "fpoins"
        : "points";
    },

    async alert(text) {
      await this.$dialogs.alert(text);
    },
  },
};
</script>

<style lang="scss" scoped>
.center {
  text-align: center;
}

.t1 {
  width: 8%;
  text-align: center;
}

.t2 {
  width: 15%;
  text-align: center;
}

.t3 {
  width: 20%;
  text-align: center;
}

.t4 {
  width: 25%;
  text-align: center;
}

.imageTable {
  width: 30px;
  margin-left: auto;
  margin-right: auto;
  display: block;
}

.imageTable--large {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 8px;
}

.preview {
  width: 140px;
  max-width: 100%;
  height: auto;
}

.question-points-label {
  line-height: 1.3;
}

.question-points-input {
  max-width: 90px;
}

.t1-e {
  width: 10%;
  text-align: center;
}

.t2-e {
  width: 30%;
  text-align: center;
}

.t3-e,
.t4-e,
.t5-e,
.t6-e {
  width: 10%;
  text-align: center;
}

.page-header-actions {
  right: 40px;
}
</style>
